///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.bid_requests = abcsetup.rfq.bid_requests || {};
abcsetup.rfq.bid_requests.copy = abcsetup.rfq.bid_requests.copy || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.bid_requests.copy = {
    init: function() {
        abcsetup.setTitle('Copy an RFQ Event');

        abcsetup.rfq.bid_requests.create.init();
    }
}